"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var platform_browser_1 = require("@angular/platform-browser");
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var http_1 = require("@angular/common/http");
var common_1 = require("@angular/common");
var core_2 = require("@ngx-translate/core");
var animations_1 = require("@angular/platform-browser/animations");
var material_module_1 = require("./material.module");
var app_component_1 = require("./app.component");
var app_routing_module_1 = require("./app-routing.module");
var core_module_1 = require("./core/core.module");
var shared_module_1 = require("./shared/shared.module");
var data_module_1 = require("./data/data.module");
var login_module_1 = require("./login/login.module");
var patient_selection_module_1 = require("./patient-selection/patient-selection.module");
var i18n_service_1 = require("./core/i18n.service");
var user_selection_module_1 = require("./user-selection/user-selection.module");
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    AppModule = tslib_1.__decorate([
        core_1.NgModule({
            imports: [
                platform_browser_1.BrowserModule,
                common_1.CommonModule,
                forms_1.FormsModule,
                http_1.HttpClientModule,
                core_2.TranslateModule.forRoot(),
                animations_1.BrowserAnimationsModule,
                material_module_1.MaterialModule,
                core_module_1.CoreModule,
                shared_module_1.SharedModule,
                login_module_1.LoginModule,
                data_module_1.DataModule,
                patient_selection_module_1.PatientSelectionModule,
                user_selection_module_1.UserAdministrationModule,
                app_routing_module_1.AppRoutingModule
            ],
            declarations: [app_component_1.AppComponent],
            providers: [
                {
                    provide: common_1.APP_BASE_HREF, useValue: '/'
                }, {
                    provide: core_1.LOCALE_ID,
                    deps: [i18n_service_1.I18nService],
                    useFactory: function (i18nService) { return i18nService.language; }
                }
            ],
            bootstrap: [app_component_1.AppComponent]
        })
    ], AppModule);
    return AppModule;
}());
exports.AppModule = AppModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBwLm1vZHVsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImFwcC5tb2R1bGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsOERBQTBEO0FBQzFELHNDQUFvRDtBQUNwRCx3Q0FBNkM7QUFDN0MsNkNBQXdEO0FBRXhELDBDQUE4RDtBQUM5RCw0Q0FBc0Q7QUFDdEQsbUVBQStFO0FBQy9FLHFEQUFtRDtBQUVuRCxpREFBK0M7QUFDL0MsMkRBQXdEO0FBRXhELGtEQUFnRDtBQUNoRCx3REFBc0Q7QUFDdEQsa0RBQWdEO0FBQ2hELHFEQUFtRDtBQUNuRCx5RkFBc0Y7QUFDdEYsb0RBQWtEO0FBQ2xELGdGQUFrRjtBQThCbEY7SUFBQTtJQUNBLENBQUM7SUFEWSxTQUFTO1FBNUJyQixlQUFRLENBQUM7WUFDTixPQUFPLEVBQUU7Z0JBQ0wsZ0NBQWE7Z0JBQ2IscUJBQVk7Z0JBQ1osbUJBQVc7Z0JBQ1gsdUJBQWdCO2dCQUNoQixzQkFBZSxDQUFDLE9BQU8sRUFBRTtnQkFDekIsb0NBQXVCO2dCQUN2QixnQ0FBYztnQkFDZCx3QkFBVTtnQkFDViw0QkFBWTtnQkFDWiwwQkFBVztnQkFDWCx3QkFBVTtnQkFDVixpREFBc0I7Z0JBQ3RCLGdEQUF3QjtnQkFDeEIscUNBQWdCO2FBQ25CO1lBQ0QsWUFBWSxFQUFFLENBQUMsNEJBQVksQ0FBQztZQUM1QixTQUFTLEVBQUU7Z0JBQ1A7b0JBQ0ksT0FBTyxFQUFFLHNCQUFhLEVBQUUsUUFBUSxFQUFFLEdBQUc7aUJBQ3hDLEVBQUU7b0JBQ0MsT0FBTyxFQUFFLGdCQUFTO29CQUNsQixJQUFJLEVBQUUsQ0FBQywwQkFBVyxDQUFDO29CQUNuQixVQUFVLEVBQUUsVUFBQyxXQUF3QixJQUFLLE9BQUEsV0FBVyxDQUFDLFFBQVEsRUFBcEIsQ0FBb0I7aUJBQ2pFO2FBQUM7WUFDTixTQUFTLEVBQUUsQ0FBQyw0QkFBWSxDQUFDO1NBQzVCLENBQUM7T0FDVyxTQUFTLENBQ3JCO0lBQUQsZ0JBQUM7Q0FBQSxBQURELElBQ0M7QUFEWSw4QkFBUyJ9


//////////////////
// WEBPACK FOOTER
// ./src/app/app.module.ts
// module id = 563
// module chunks = 0